import { CourseService } from './../../../_services/course.service';
import { Subscription } from 'rxjs';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';
import { ChartOptions } from '../../dashboard/dashboard.component';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalService } from '../../../global/global.service';
import { DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { PaginationInfo } from '../../../_models/pagination-info';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ResponseStructure, parseToDate } from '@iq-central-front-end/share';

@Component({
  selector: 'iq-central-front-end-course-details',
  templateUrl: './course-details.component.html',
  styleUrls: ['./course-details.component.scss'],
})
export class CourseDetailsComponent implements OnInit, OnDestroy {
  tags;
  reviews;
  paginationInfo: PaginationInfo;
  course: any[] = [];
  comments: any[] = [];
  commentLength: any;
  reply: any[] = [];
  expectations: any[] = [];
  totalRecords: any;
  page: any;

  @ViewChild('chart') chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;
  sub: Subscription = new Subscription();
  courseCode: string;
  courseData: any;
  isEnrolled: boolean;
  content: any;
  ratingForm: FormGroup;
  replyForm: FormGroup;
  commentForm: FormGroup;
  filePath: any;
  duration: any;
  lessons: any;
  description: any;
  lists: any[] = [1, 2, 3, 4, 5];
  currentPageUrl: string;
  facebookUrl: string;
  whatsappUrl: string;
  linkedInUrl: string;
  emailUrl: string;
  twitterUrl: string;
  LikedCourses: any[] = [];
  str = 'Hello world!!!';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _global: GlobalService,
    private _course: CourseService,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder
  ) {
    this.chartOptions = {
      series: [44, 44, 44],
      chart: {
        type: 'donut',
      },
      labels: ['Failed Attempts', 'Ongoing Courses', 'Passed Courses'],
      colors: ['#EA5E5E', '#FFC061', '#1CB4AE'],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 300,
            },
            legend: {
              show: false,
              position: 'bottom',
            },
          },
        },
      ],
      dataLabels: {
        enabled: false,
      },
    };
  }

  ngOnInit(): void {
    this.courseCode = this.route.snapshot.paramMap.get('code');
    this.initRatingForm();
    this.initCommentForm();
    this.initReplyForm();
    this.route.data.subscribe((res) => {
      this.courseData = res['resolvedData'].responseResult;
      this.course = this.courseData;
      this.lessons = this.courseData['lessons'];
      console.log(this.courseData, this.lessons);
    });
    this.getComments();
    this.isEnrolled = this.courseData.hasEnrolled;
    this.duration = parseToDate(this.courseData.duration);
    this.description = this.courseData.description;
    this.tags = [
      'Marketing Strategies',
      'Life',
      'pin',
      'Business Analysis',
      'Wordpress',
    ];
    this.expectRating();

    this.currentPageUrl = window.location.href;
    this.facebookUrl = `${'https://www.facebook.com/sharer/sharer.php?u='}${
      this.currentPageUrl
    }`;
    this.whatsappUrl = `${'whatsapp://send?text='}${this.currentPageUrl}`;
    this.linkedInUrl = `${'https://www.linkedin.com/shareArticle?mini=true&url='}${
      this.currentPageUrl
    }${'&t='}${this.courseData.title}`;
    this.twitterUrl = `${'https://twitter.com/share?url='}${
      this.currentPageUrl
    }${'&text='}${this.courseData.title}`;
    this.emailUrl = `${'mailto:?subject='}${this.courseData.title}${'&body='}${
      this.currentPageUrl
    }`;
  }

  initRatingForm() {
    this.ratingForm = this.fb.group({
      message: [''],
      rating: [1],
    });
  }

  initCommentForm() {
    this.commentForm = this.fb.group({
      message: ['', [Validators.required]],
    });
  }

  initReplyForm() {
    this.replyForm = this.fb.group({
      message: [''],
    });
  }

  expectRating() {
    for (let i = 1; i <= 5; i++) {
      if (this.course['courseRatings'].length === 0) {
        this.expectations = [0, 0, 0, 0, 0, 0];
      } else {
        const ratingLength = this.course['courseRatings'].length;
        const ratings = this.course['courseRatings'].map(
          (courseRating) => courseRating['rating']
        );
        const totalRate = ratings.filter((rate) => rate === i).length;
        const totalPercent = (totalRate / ratingLength) * 100;
        this.expectations.push(totalPercent);
      }
    }

    return this.expectations;
  }

  delete() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This course will be deleted and cannot be undone',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1CB4AE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Delete',
    }).then((result) => {
      if (result.value) {
        this.deleteCourse(this.courseCode);
      }
    });
  }

  deleteCourse(courseCode: string) {
    this._global.showSpinner();

    this.sub.add(
      this._course.deleteCourse(courseCode).subscribe({
        next: (res: ResponseStructure) => {
          this._global.globalSuccessHandler(res);
          this.router.navigate(['/courses']);
        },
      })
    );
  }

  setFilePathAndTypeAdmin(content) {
    this.content = content;
    if (content.contentType === 'pdf') {
      this.filePath = content.lessonContentPdf.filePath;
      console.log(this.filePath, content.contentType);
    } else if (content.contentType === 'QUIZ') {
      const id = content.id;
      this.router.navigate(['/courses/serveQuiz', id]);
    } else {
      this.filePath = content.lessonContentVideo.filePath;
      console.log(this.filePath, content.contentType);
    }
  }
  setFilePathAndTypeStaff(content) {
    const payload = {
      courseId: this.courseData.id,
      lessonContentId: content.id,
    };
    this.content = content;

    if (content.contentType === 'pdf') {
      this.filePath = content.lessonContentPdf.filePath;
      if (this.isEnrolled) {
        this.getContent(payload.lessonContentId);
      }
    } else if (content.contentType === 'QUIZ') {
      this.router.navigate(['/courses/serveQuiz', content.id]);
    } else {
      this.filePath = content.lessonContentVideo.filePath;
      if (this.isEnrolled) {
        this.getContent(payload.lessonContentId);
      }
    }
  }

  getContent(contentId) {
    this.sub.add(
      this._course.getOneContent(contentId).subscribe({
        next: (res) => {
          this.courseData.watchedContents.includes(contentId)
            ? null
            : this.courseData.watchedContents.push(contentId);
        },
      })
    );
  }

  openCertificate() {
    const certificate = this.courseData.certificateFileUrl;
    window.open(certificate);
    console.log(this.courseData.certificateFileUrl);
  }

  transformRating(rating) {
    if (rating === 1) {
      return 'one';
    } else if (rating === 2) {
      return 'two';
    } else if (rating === 3) {
      return 'three';
    } else if (rating === 4) {
      return 'four';
    } else if (rating === 5) {
      return 'five';
    }
  }

  rateCourse() {
    const payload = this.ratingForm.value;
    this._global.showSpinner();
    this.sub.add(
      this._course.rateCourse(this.courseCode, payload).subscribe({
        next: (res) => {
          this._global.hideSpinner();
          this._global.toast('success', 'Thank you for your review &#128521;');
        },
      })
    );
  }

  commentCourse() {
    const payload = this.commentForm.value;

    this._global.showSpinner();
    this.sub.add(
      this._course.createComment(this.courseCode, payload).subscribe({
        next: (res) => {
          this._global.hideSpinner();
          this.comments.push(res['responseResult']);
          this._global.toast('success', 'Sent &#128521;');
        },
      })
    );
  }

  replyComments(commentId, i) {
    const payload = this.replyForm.value;

    this._global.showSpinner();
    this.sub.add(
      this._course.replyComments(commentId, payload).subscribe({
        next: (res) => {
          this._global.hideSpinner();
          this.comments[i].replies.push(res['responseResult']);
          this._global.toast('success', 'Sent &#128521;');
        },
      })
    );
  }

  getComments() {
    this._global.showSpinner();
    this.sub.add(
      this._course.getComments(this.courseCode, 1, 5).subscribe({
        next: (res) => {
          this._global.hideSpinner();
          this.comments = res['responseResult'].comments;
          this.commentLength =
            res['responseResult'].paginationInfo.totalElements;
        },
      })
    );
  }

  enroll() {
    this.sub.add(
      this._course.toggleEnroll(this.courseCode).subscribe({
        next: (res) => {
          this.isEnrolled = true;
          this.courseData.hasEnrolled = true;
          this._global.toast(
            'success',
            'You have successfully Enrolled for this course'
          );
        },
      })
    );
  }

  // unEnroll() {
  //   this.sub.add(
  //     this._course.unEnroll(this.courseCode).subscribe({
  //       next: res => {
  //         this.isEnrolled = false;
  //         this.courseData.hasEnrolled = false;
  //         ;
  //         this._global.toast(
  //           'success',
  //           'You have successfully Un Enrolled for this course'
  //         );
  //       }
  //     })
  //   );
  // }

  navigatePage(page) {
    this._global.showSpinner();
    this._course.getComments(this.courseCode, page, 3).subscribe({
      next: (res) => {
        this._global.hideSpinner();
        this.comments = res['responseResult'].comments;
        this.paginationInfo = res['responseResult'].paginationInfo;
      },
    });
  }

  likeDislikeCourse(event, data) {
    if (
      event.target.nextSibling.firstChild.classList.contains('fa-thumbs-down')
    ) {
      event.target.nextSibling.firstChild.classList.remove('fa-thumbs-down');
      event.target.nextSibling.firstChild.classList.add('fa-thumbs-up');
    } else {
      event.target.nextSibling.firstChild.classList.add('fa-thumbs-down');
      event.target.nextSibling.firstChild.classList.remove('fa-thumbs-up');
    }

    this.LikedCourses.includes(data)
      ? (this.LikedCourses = this.LikedCourses.filter((s) => s !== data))
      : this.LikedCourses.push(data);

    console.log(this.LikedCourses);

    const payload = this.LikedCourses;

    this.sub.add(
      this._course.toggleLikeCourse(data.code, payload).subscribe({
        next: (res: ResponseStructure) => {
          this._global.globalSuccessHandler(res);
        },
      })
    );
  }

  goToChoosenRoute(route) {
    this.router.navigate([route]);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
